import React, { useEffect } from "react";
import { FiGrid, FiList, FiSearch } from "react-icons/fi";
import BotaoExportacao from "../../components/Exportacao";
import { SoIcone } from "../../components/ListaCompacta/styles";
import NavegacaoEtapa from "../../components/NavegacaoEtapa";
import {
  HeaderControls,
  HeaderMeta,
  HeaderMetaDot,
  HeaderRow,
  HeaderTitleBlock,
  SearchBox,
  SearchIcon,
  SearchInput,
  StickyHeaderSlot,
  Titulo,
  ViewSwitcher,
  ViewToggleButton,
} from "./styles";

export default function HeaderBar({
  ambientesCount,
  itensCount,
  vencidosCount,
  query,
  onQueryChange,
  viewMode,
  onViewModeChange,
  searchInputRef,
  exportPayload,
}) {
  useEffect(() => {
    function onKey(event) {
      if (event.key === "/" && document.activeElement?.tagName !== "INPUT") {
        event.preventDefault();
        searchInputRef?.current?.focus();
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [searchInputRef]);

  return (
    <StickyHeaderSlot>
      <HeaderRow>
        <HeaderTitleBlock>
          <NavegacaoEtapa>
            <Titulo>Pintura &amp; Lacagem</Titulo>
          </NavegacaoEtapa>
          <HeaderMeta>
            <span>
              {itensCount} {itensCount === 1 ? "item pendente" : "itens pendentes"}
            </span>
            <HeaderMetaDot aria-hidden>·</HeaderMetaDot>
            <span>
              {ambientesCount} {ambientesCount === 1 ? "ambiente" : "ambientes"}
            </span>
            <HeaderMetaDot aria-hidden>·</HeaderMetaDot>
            <span style={{ color: vencidosCount > 0 ? "var(--danger-text, inherit)" : "inherit" }}>
              {vencidosCount} {vencidosCount === 1 ? "vencido" : "vencidos"}
            </span>
          </HeaderMeta>
        </HeaderTitleBlock>

        <HeaderControls>
          <SearchBox>
            <SearchIcon>
              <FiSearch size={14} />
            </SearchIcon>
            <SearchInput
              ref={searchInputRef}
              type="search"
              value={query}
              onChange={(event) => onQueryChange(event.target.value)}
              placeholder="Cliente, ambiente, item, lote, descrição…  (/)"
              aria-label="Buscar em Pintura & Lacagem"
            />
          </SearchBox>

          <ViewSwitcher role="group" aria-label="Modo de visualização">
            <ViewToggleButton
              type="button"
              $active={viewMode === "itens"}
              aria-pressed={viewMode === "itens"}
              title="Itens"
              onClick={() => onViewModeChange("itens")}
            >
              <FiList size={14} />
              Itens
            </ViewToggleButton>
            <ViewToggleButton
              type="button"
              $active={viewMode === "ambientes"}
              aria-pressed={viewMode === "ambientes"}
              title="Ambientes"
              onClick={() => onViewModeChange("ambientes")}
            >
              <FiGrid size={14} />
              Ambientes
            </ViewToggleButton>
          </ViewSwitcher>

          {exportPayload && (
            <SoIcone>
              <BotaoExportacao
                titulo={exportPayload.titulo}
                resumo={exportPayload.resumo}
                secoes={exportPayload.secoes}
                visual={exportPayload.visual}
              />
            </SoIcone>
          )}
        </HeaderControls>
      </HeaderRow>
    </StickyHeaderSlot>
  );
}
